import { Observable } from 'rxjs';
import { Visit } from '../../models/visit.model';
import { BaseCondition } from './base.condition';
import { NotificationService } from '../../services';
import { ConditionFailReason } from '../../models';

export class PageCountCondition extends BaseCondition {
  constructor(path: string, visits: Visit[], options: any, notificationService: NotificationService) {
    super("PageCountCondition",notificationService);
      const TIMESTAMPMULTIPLIER = 60 * 1000;
      let pageLastVisits: Visit[];
      let span: number;
        this.observable = new Observable(observer => {
          if (!options.hasOwnProperty('Min') && !options.hasOwnProperty('Max')) {
            this.onConditionFail(ConditionFailReason.ConfigurationError, "Mandatory Min/Max or both parameters are missing. PageCountCondition condition failed!!");
            observer.next(false);
            return;
          }

          if (!path) { //Invalid path passed.
            this.onConditionFail(ConditionFailReason.ConfigurationError,"Path missing.PageCountCondition failed!!");
            observer.next(false);
            return;
          }
          span = options.hasOwnProperty("MinutesWithin") ? options.MinutesWithin : Infinity;
          let spanStart = (span != Infinity) ? Date.now() - span * TIMESTAMPMULTIPLIER : 0;
          pageLastVisits = visits.filter(x => x.hasOwnProperty('TimeStamp') && x.TimeStamp >= spanStart && x.Path === path);
          console.log(`No of time page visited in last ${span} minutes is :: ${pageLastVisits.length}`);

          if (options.hasOwnProperty("Max") && pageLastVisits.length > options.Max) {
            observer.next(false);
            this.onConditionFail(ConditionFailReason.CriteriaFail,"PageCountCondition failed!!");
            return;
          }
          if (options.hasOwnProperty("Min") && pageLastVisits.length < options.Min) {
            observer.next(false);
            this.onConditionFail(ConditionFailReason.CriteriaFail,"PageCountCondition failed!!");
            return;
          }
          
          observer.next(true);
          console.log("PageCountCondition passed!!");
          return;
      });
    }
}
